import * as React from "react";
import { Helmet } from "react-helmet";
import { ClaimDetailsPage } from "./ClaimDetailsPage";
import { ClaimsPage } from "./ClaimsPage";
import { ContactUsCard } from "kw/components/ContactUs/ContactUsCard";
import { CustomerDetailsPage } from "./CustomerDetailsPage";
import { CustomersPage } from "./CustomersPage";
import { DashboardPage } from "./DashboardPage";
import { Error404Page } from "kw/quoting/pages/Error404Page";
import { GlobalsContext } from "kw/util/Globals";
import { GlobalSettingsPage } from "./GlobalSettingsPage";
import { PasswordLessUserRegisterPage } from "../quoting/pages/PasswordLessUserRegisterPage";
import { PoliciesPage } from "./PoliciesPage";
import { PolicyDetailsPage } from "./PolicyDetailsPage";
import { QuoteDetailsPage } from "./QuoteDetailsPage";
import { QuotesPage } from "./QuotesPage";
import { ReportsPage } from "./ReportsPage";
import { Router } from "@reach/router";
import { RouterOutlet } from "kw/components/RouterOutlet/RouterOutlet";
import { SettingsPage } from "./SettingsPage";
import { useUser } from "kw/auth/useUser";

export const AdminMain = () => {
  const user = useUser();

  return (
    <GlobalsContext.Provider value="admin">
      <Helmet>
        <title>{`Dashboard - ${user?.organization?.name}`}</title>
      </Helmet>
      <Router basepath="/admin">
        <Error404Page default />
        <RouterOutlet
          component={DashboardPage}
          path="/"
          layoutOverrides={{
            hideBackButton: true,
          }}
        />
        <RouterOutlet
          component={CustomersPage}
          path="/customers"
          layoutOverrides={{
            hideBackButton: true,
          }}
        />
        <RouterOutlet
          component={CustomerDetailsPage}
          path="customers/:customerId"
          layoutOverrides={{
            hideBackButton: true,
          }}
        />
        <RouterOutlet
          component={QuotesPage}
          path="/quotes"
          layoutOverrides={{
            hideBackButton: true,
          }}
        />
        <RouterOutlet
          component={QuoteDetailsPage}
          path="quotes/:quoteId/*"
          layoutOverrides={{
            hideBackButton: true,
          }}
        />
        <RouterOutlet
          component={PoliciesPage}
          path="/policies"
          layoutOverrides={{
            hideBackButton: true,
          }}
        />
        <RouterOutlet
          component={PolicyDetailsPage}
          path="policies/:policyId"
          layoutOverrides={{
            hideBackButton: true,
          }}
        />
        <RouterOutlet
          component={ClaimsPage}
          path="/claims"
          layoutOverrides={{
            hideBackButton: true,
          }}
        />
        <RouterOutlet
          component={ClaimDetailsPage}
          path="claims/:claimId"
          layoutOverrides={{
            hideBackButton: true,
          }}
        />
        <RouterOutlet
          component={ReportsPage}
          path="/reports"
          layoutOverrides={{
            hideBackButton: true,
          }}
        />
        <RouterOutlet component={SettingsPage} path="/settings" />
        <RouterOutlet
          component={ContactUsCard}
          path="/contact-us"
          layoutOverrides={{
            hideBackButton: true,
            headerText: "Contact Us",
            showHeader: true,
          }}
        />
        <RouterOutlet
          component={PasswordLessUserRegisterPage}
          path="/password-less-register"
        />
        <RouterOutlet
          component={GlobalSettingsPage}
          path="global-settings"
          layoutOverrides={{
            headerText: "Global Settings",
            hideBackButton: true,
            showHeader: true,
          }}
        />
      </Router>
    </GlobalsContext.Provider>
  );
};
